/**
 * Sync uploaded profile avatar to the site header account icon.
 * Sources: sessionStorage cache, renogy:user-avatar-updated event, optional DTC profile fetch.
 */
(function () {
  var STORAGE_KEY = 'renogy_user_avatar_url';
  var PROFILE_PATH = '/api/v1/dtc/account/profile';

  function getApiDomain() {
    return (window.renogyConfig && window.renogyConfig.apiUrl) || '';
  }

  function getAccessToken() {
    var mode = (window.renogyConfig && window.renogyConfig.mode) || 'prod';
    var key = 'renogy_account_access_token_key_' + mode + '_1.0';
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readCachedUrl() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function writeCachedUrl(url) {
    try {
      if (url) sessionStorage.setItem(STORAGE_KEY, url);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function applyHeaderAvatar(url) {
    var safeUrl = String(url || '').trim();
    document.querySelectorAll('[data-header-account]').forEach(function (root) {
      var avatar = root.querySelector('[data-header-avatar]');
      var fallback = root.querySelector('[data-header-account-default]');
      if (!avatar) return;

      if (safeUrl) {
        avatar.src = safeUrl;
        avatar.hidden = false;
        if (fallback) fallback.hidden = true;
      } else {
        avatar.removeAttribute('src');
        avatar.hidden = true;
        if (fallback) fallback.hidden = false;
      }
    });
  }

  function fetchProfileAvatar() {
    var token = getAccessToken();
    var domain = getApiDomain();
    if (!token || !domain) return Promise.resolve('');

    return fetch(domain + PROFILE_PATH, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Token': token,
      },
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (res) {
        if (!res || res.code !== '000000' || !res.data) return '';
        return res.data.userImage || res.data.avatar || '';
      })
      .catch(function () {
        return '';
      });
  }

  function init() {
    var cached = readCachedUrl();
    if (cached) applyHeaderAvatar(cached);

    document.addEventListener('renogy:user-avatar-updated', function (event) {
      var url = (event && event.detail && event.detail.url) || '';
      writeCachedUrl(url);
      applyHeaderAvatar(url);
    });

    // Logged-in pages: refresh from profile when cache is empty.
    if (!cached && getAccessToken()) {
      fetchProfileAvatar().then(function (url) {
        if (!url) return;
        writeCachedUrl(url);
        applyHeaderAvatar(url);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
